/**
 * A global namespace for mouse click events.
 */
const mouseClickEvents = { down: 'mousedown', up: 'mouseup' };
export default mouseClickEvents;
